import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Chip, ClickAwayListener, Tooltip, Typography } from '@mui/material';
var QUESTION_HEADER_STRINGS = appStrings.modules.questionnaire;
var ToolTipItem = function (_a) {
    var title = _a.title, tooltipText = _a.tooltipText, tooltipCount = _a.tooltipCount;
    var _b = useState(false), isTooltipOpen = _b[0], setIsTooltipOpen = _b[1];
    return (_jsxs(Box, { sx: tooltipItemSx(tooltipCount), children: [_jsx(Typography, { variant: "text-xs-semibold", color: function (_a) {
                    var backrs = _a.backrs;
                    return backrs.colors['Colors/Text/text-quaternary'];
                }, children: title }), _jsx(ClickAwayListener, { onClickAway: function () { return setIsTooltipOpen(false); }, children: _jsx(Tooltip, { open: isTooltipOpen, onClose: function () { return setIsTooltipOpen(false); }, title: tooltipText, placement: "top", arrow: true, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, componentsProps: {
                        tooltip: {
                            sx: toolTipComponentSx,
                        },
                    }, children: _jsx(Box, { onClick: function () { return setIsTooltipOpen(function (prev) { return !prev; }); }, sx: iconContainerSx, children: _jsx(AppIcon, { iconName: "HelpCircle", diameter: "16px", color: "Colors/Foreground/fg-quinary" }) }) }) })] }, title));
};
export var QuestionHeader = function (_a) {
    var title = _a.title, subCategory = _a.subCategory, description = _a.description, tooltips = _a.tooltips;
    return (_jsxs(Box, { sx: containerSx, children: [_jsxs(Box, { sx: titleContainerSx, children: [_jsxs(Box, { sx: titleSubCategoryContainerSx, children: [_jsx(Typography, { variant: "text-lg-medium", component: "div", color: function (_a) {
                                    var backrs = _a.backrs;
                                    return backrs.colors['Colors/Text/text-primary'];
                                }, children: title }), _jsx(Chip, { variant: "pill", size: "sm", label: subCategory, sx: chipSx })] }), _jsx(Typography, { variant: "text-sm-regular", color: function (_a) {
                            var backrs = _a.backrs;
                            return backrs.colors['Colors/Text/text-tertiary'];
                        }, children: description.replace(/--/g, '—') })] }), _jsxs(Box, { sx: tableHeaderContainerSx, children: [_jsx(Typography, { variant: "text-xs-semibold", component: "div", sx: firstColumnHeaderSx, children: QUESTION_HEADER_STRINGS.facet }), _jsx(Box, { sx: toolTipContainerSx, children: tooltips.map(function (tooltip) { return (_jsx(ToolTipItem, { title: tooltip.title, tooltipText: tooltip.tooltip, tooltipCount: tooltips.length }, tooltip.title)); }) })] })] }));
};
var containerSx = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
};
var titleContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        py: backrs.spacing['spacing-2xl'],
        px: {
            xs: backrs.spacing['spacing-xl'],
            md: backrs.spacing['spacing-3xl'],
        },
        display: 'flex',
        flexDirection: 'column',
    });
};
var toolTipContainerSx = {
    width: '75%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    transition: 'all 0.3s ease-in-out',
};
var toolTipComponentSx = {
    whiteSpace: 'pre-line',
    padding: '16px',
    fontFamily: 'Sarabun, sans-serif',
};
var tooltipItemSx = function (numTooltips) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            width: "calc(100% / ".concat(numTooltips, ")"),
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            px: {
                xs: backrs.spacing['spacing-xl'],
                md: backrs.spacing['spacing-3xl'],
            },
            gap: backrs.spacing['spacing-xs'],
            transition: 'all 0.3s ease-in-out',
        });
    };
};
var chipSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        backgroundColor: backrs.colors['Brand/50'],
        borderColor: backrs.colors['Brand/200'],
        color: backrs.colors['Brand/700'],
    });
};
var titleSubCategoryContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: backrs.spacing['spacing-md'],
    });
};
var tableHeaderContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        borderTop: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
    });
};
var firstColumnHeaderSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Colors/Text/text-quaternary'],
        width: '25%',
        py: backrs.spacing['spacing-lg'],
        px: backrs.spacing['spacing-3xl'],
        borderRight: "1px solid ".concat(backrs.colors['Colors/Border/border-secondary']),
    });
};
var iconContainerSx = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
